import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, Form, Grid, Popup, Label, Icon, Dimmer, Loader, Segment, Card, Image, Confirm, Checkbox } from "semantic-ui-react";
import moment from "moment";
import { Field, Formik } from "formik";
import MainButtonsContainer from "features/FolderManager/components/MainButtonsContainer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEuroSign } from "@fortawesome/free-solid-svg-icons";
import servipay from "assets/image/servipay.png";
import sumup from "assets/image/sumup.png";
import cash from "assets/image/cash.jpg";
import CustomTextareaComponent from "components/Form/CustomTextareaComponent";
import TotalCostModal from "../modals/TotalCostModal";
import PaymentModal from "../modals/PaymentModal";
import { toast } from "react-toastify";

const styles = {
	mainContainer: {
		backgroundColor: "rgb(1, 111, 97)",
		color: "#fff",
		padding: 10,
		borderRadius: "4px",
		border: "1px solid rgb(1, 111, 97)",
		boxShadow: "0px 9px 20px -23px rgba(148,148,148,1)",
		minHeight: 80,
		marginBottom: 10,
		width: "100%",
		display: "flex",
		alignItems: "center",
	},
	blocInfoHeader: {
		mainContainer: {
			padding: 5,
			borderRadius: 4,
			display: "flex",
			alignItems: "center",
		},
		label: {
			fontSize: "0.7em",
		},
		totalPrice: {
			fontSize: "1em",
			fontWeight: 600,
		},
		button: {
			cursor: "pointer",
			color: "white",
			border: "1px white solid",
			borderRadius: 4,
			textAlign: "center",
			marginTop: 5,
			backgroundColor: "transparent",
			padding: 5,
		},
		noAction: {
			color: "white",
			border: "1px white solid",
			borderRadius: 4,
			textAlign: "center",
			marginTop: 5,
			backgroundColor: "transparent",
			padding: 5,
		},
	},
};
const FolderSection = ({
	data,
	mode,
	isUrgent,
	isMobile,
	t,
	role,
	costs,
	folderManager,
	blueCardColor,
	updateCommentAndPostit,
	isPaymentEnabled,
	isNotPaid,
	amoutAlreadyPaid,
	getPaymentsBySource,
	amountToPay,
	getPaymentPartition,
	addPayment,
	folderPaymentCancel,
	folderIsPaid,
	analysisLibraryCosts,
	invoices,
	showDeposit,
	setShowDeposit,
	removeDeposit,
	setActiveTabIndex,
	folderPaymentRef,
}) => {
	const [openPaymentOptionsModal, setOpenPaymentOptionsModal] = useState(false);
	const [paymentOptionsModalLoading, setPaymentOptionsModalLoading] = useState(false);
	const [confirmCancelPaymentId, setConfirmCancelPaymentId] = useState(0);
	const [confirmCancelPaiementOpen, setConfirmCancelPaiementOpen] = useState(false);
	const [totalCostModal, setTotalCostModal] = useState(false);
	const [showPatientPostIt, setShowPatientPostIt] = useState(false);
	const [openInvoicesModal, setOpenInvoicesModal] = useState(false);
	const [openDepositConfirmCancel, setOpenDepositConfirmCancel] = useState(false);

	const toggleShowPatientPostIt = () => {
		setShowPatientPostIt(!showPatientPostIt);
	};
	const openTotalCostModal = async () => {
		await folderIsPaid(folderManager.focusID[0]);
		setTotalCostModal(true);
	};

	const isInvoicesPaid = () => {
		return folderManager.paid && folderManager.paid.payments && folderManager.paid.payments?.some((pay) => !pay.prescription);
	};

	const folderPaidWithInvoice = () => {
		return (
			folderManager.paid &&
			folderManager.paid.payments &&
			folderManager.paid.payments.length > 0 &&
			folderManager.paid.payments?.some((pay) => !pay.invoice_reference && pay.source === "toBill")
		);
	};

	const amountInvoicesToPay = () => {
		return invoices?.reduce((acc, inv) => {
			if (folderManager.paid.payments.some((pay) => pay.invoice_reference === inv.reference)) {
				let amountPaid = folderManager.paid.payments
					.filter((pay) => pay.invoice_reference === inv.reference)
					.reduce((acc, payment) => acc + payment.price, 0);
				return acc + inv.amount - amountPaid;
			}
			return acc + inv.amount;
		}, 0);
	};

	const amountInvoicesPaid = () => {
		return folderManager.paid.payments.filter((pay) => !pay.prescription).reduce((acc, payment) => acc + payment.price, 0);
	};

	return (
		<Formik
			enableReinitialize={true}
			initialValues={{
				comment: data.folders[0].comment ? data.folders[0].comment : data.prescriptions[0]?.comment ?? "",
				post_it: data.patient.post_it ?? "",
			}}
			onSubmit={async (values) => {
				await updateCommentAndPostit(data.folders[0].id, values);
				toggleShowPatientPostIt();
			}}
		>
			{({ submitForm }) => (
				<Form style={{ marginBottom: 15 }}>
					<MainButtonsContainer mode={mode}>
						<Grid.Row
							style={{
								...styles.mainContainer,
								...blueCardColor(isUrgent, data.prescriptions),
							}}
							className={isMobile() ? "mainButtonsGreenContainerMobile" : ""}
						>
							<Grid.Column mobile={16} tablet={16} computer={16} style={{ marginBottom: isMobile() ? 10 : 0 }}>
								<Grid style={{ margin: isMobile() ? 0 : "-1em" }}>
									<Grid.Row style={{ paddingBottom: 0 }}>
										<Grid.Column style={{ paddingLeft: 0 }} mobile={16} tablet={16} computer={16}>
											<Grid style={{ margin: isMobile() ? 0 : "-1em" }}>
												<Grid.Row style={{ paddingBottom: 0 }}>
													<Grid.Column mobile={8} tablet={5} computer={4}>
														{t("folderManager.folder_2")}{" "}
														<span
															style={{ cursor: "copy", position: "inherit", padding: "0.5em", zIndex: 10 }}
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																navigator.clipboard.writeText(data.folders[0]?.code);
																toast.success("Numéro de dossier copié !");
															}}
														>
															{" "}
															{data.folders[0]?.code}
														</span>
													</Grid.Column>
													<Grid.Column mobile={16} tablet={4} computer={4}>
														{data.folders[0]?.center ? (
															data.folders[0]?.center?.name
														) : data.folders[0].roadAppointments?.length > 0 ? (
															<Popup content="Infos de la tournée à venir" size="mini" position="right center" trigger={<span>En tournée</span>} />
														) : (
															"Pas de centre"
														)}
														{data.folders[0].labAppointment && (
															<span style={{ paddingLeft: "10px" }}>
																<Icon name="time" />{" "}
																{data.folders[0].labAppointment._time.substring(data.folders[0].labAppointment._time.length - 3, 0)}
															</span>
														)}
													</Grid.Column>

													<Grid.Column mobile={8} tablet={3} computer={4}>
														{t("folderManager.status") +
															(data.folders[0]?.status === "DONE"
																? t("folderManager.done")
																: data.folders[0]?.status === "CANCELED"
																? t("folderManager.canceled")
																: data.folders[0]?.status === "PENDING"
																? t("folderManager.pending")
																: data.folders[0]?.status === "HELP_NURSE"
																? t("folderManager.helpNurse")
																: t("folderManager.inProgress"))}
														{data.folders[0]?.status === "CANCELED" && data.folders[0]?.canceled_reason && (
															<>
																<span style={{ margin: "0 10px" }}>-</span>
																<span>{data.folders[0]?.canceled_reason}</span>
															</>
														)}
														<span onClick={() => setOpenInvoicesModal(true)}>&nbsp;</span>
													</Grid.Column>

													<Grid.Column
														mobile={16}
														tablet={3}
														computer={4}
														style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between" }}
													>
														<div>
															{t("folderManager.deposit")}
															<Checkbox
																slider
																style={{ marginLeft: "8px", fontSize: "0.8em" }}
																checked={showDeposit}
																onChange={(e, infos) => {
																	if (infos.checked) {
																		if (data.deposit) setOpenDepositConfirmCancel(true);
																		else setActiveTabIndex("prescriptions");
																	} else {
																		setActiveTabIndex("deposit");
																	}
																}}
																onMouseDown={(e) => {
																	setShowDeposit(!showDeposit);
																	e.preventDefault();
																	e.stopPropagation();
																}}
																disabled={data.isDone}
															/>
														</div>
														{isUrgent && (
															<Label color="black" style={{ marginLeft: "10px" }}>
																Urgent
															</Label>
														)}
														<Confirm
															open={openDepositConfirmCancel}
															cancelButton="Annuler"
															confirmButton="Confirmer"
															onCancel={() => {
																setShowDeposit(true);
																setOpenDepositConfirmCancel(false);
																setActiveTabIndex("deposit");
															}}
															onConfirm={() => {
																setShowDeposit(false);
																removeDeposit(data.folders[0].id);
																setOpenDepositConfirmCancel(false);
																setActiveTabIndex("prescriptions");
															}}
															content="Etes-vous sûr de vouloir supprimer les données du dépôt ?"
														/>
													</Grid.Column>
												</Grid.Row>
											</Grid>
										</Grid.Column>
										<Grid.Column
											mobile={16}
											tablet={8}
											computer={8}
											style={{
												display: "flex",
												justifyContent: "flex-end",
											}}
										></Grid.Column>
									</Grid.Row>

									<Grid.Row style={{ paddingBottom: 15 }}>
										<Grid.Column style={{ paddingLeft: 0 }} mobile={16} tablet={6} computer={6}>
											{data.prescriptions.length !== 0 && (role === "NURSE" || mode === "edit") && (
												<Grid style={{ padding: "0 1rem" }}>
													<Grid.Row
														style={{
															paddingBottom: isPaymentEnabled() ? 0 : 15,
														}}
													>
														<Grid.Column mobile={8} tablet={8} computer={16}>
															<div style={styles.blocInfoHeader.mainContainer}>
																<div
																	style={{
																		height: "100%",
																		display: "flex",
																		alignItems: "center",
																		paddingRight: "0.5em",
																	}}
																>
																	<FontAwesomeIcon
																		icon={faEuroSign}
																		style={{
																			fontSize: "1.5em",
																		}}
																	/>
																</div>
																<div
																	style={{
																		height: "100%",
																		display: "flex",
																		flexFlow: "column",
																	}}
																>
																	<div style={styles.blocInfoHeader.label}>{t("folderManager.patientPayable")}</div>
																	<div>
																		<span style={{ paddingRight: "10px" }}>Dossier en cours</span>{" "}
																		<Popup
																			content="Détail prix du dossier"
																			size="mini"
																			position="right center"
																			trigger={<Icon name="info circle" onClick={openTotalCostModal} />}
																		/>{" "}
																	</div>
																	<div
																		style={{
																			height: "100%",
																			display: "flex",
																			flexFlow: "raw",
																		}}
																	>
																		{data.infos.prescriptionStatus && (
																			<span style={{ padding: "0 20px" }}>
																				{costs?.totalCosts?.patient.toFixed(2)} {t("folderManager.devise")}
																			</span>
																		)}
																		{costs?.totalCosts?.patient.toFixed(2) > 0 && (
																			<div style={{ fontWeight: "bold" }}>
																				{folderManager.paid.payments.length > 0 ? (
																					amountToPay() > 0 ? (
																						<div style={{ display: "flex" }}>
																							<Icon name="warning" color="red" />
																							<span>{t("folderManager.stillCollected")}</span>
																						</div>
																					) : folderPaidWithInvoice() ? (
																						t("folderManager.invoiced")
																					) : (
																						<div style={{ display: "flex" }}>
																							<Icon name="check" />
																							<span>{t("folderManager.cashed")}</span>
																						</div>
																					)
																				) : (
																					t("folderManager.toCashed")
																				)}
																			</div>
																		)}
																	</div>
																	{invoices?.length > 0 && (
																		<>
																			<span>
																				{invoices?.length} {invoices?.length >= 2 ? "anciennes factures" : "ancienne facture"}
																			</span>
																			{+amountInvoicesToPay().toFixed(2) > 0 && (
																				<div style={{ display: "flex", alignItems: "baseline" }}>
																					<Icon name="angle double right" color="red" />
																					<span style={{ padding: "0 10px" }}>{amountInvoicesToPay().toFixed(2)} € à encaisser</span>
																				</div>
																			)}
																			{+amountInvoicesToPay().toFixed(2) === 0 && (
																				<div style={{ display: "flex" }}>
																					<Icon name="check" />
																					{+amountInvoicesPaid().toFixed(2)}
																					{" € "}
																					<span>{t("folderManager.cashed")}</span>
																				</div>
																			)}
																		</>
																	)}
																	{invoices?.length === 0 && folderManager.paid.payments.some((p) => !p.prescription) && (
																		<>
																			<span>Encaissement factures</span>
																			<div>
																				{+amountInvoicesPaid().toFixed(2)}
																				{" €"}
																			</div>
																		</>
																	)}
																</div>
															</div>
														</Grid.Column>
													</Grid.Row>
													<Grid.Row
														style={{
															paddingTop: 0,
															marginBottom: 10,
														}}
													>
														<Grid.Column mobile={8} tablet={8} computer={8}>
															{!isPaymentEnabled() && costs?.totalCosts?.patient.toFixed(2) > 0 && data.isDone && isNotPaid() && "Paiement non réglé"}
															{data.infos.prescriptionStatus && (costs?.totalCosts?.patient > 0 || invoices.length > 0 || isInvoicesPaid()) && (
																<Button
																	compact
																	onClick={(e) => {
																		if (e !== undefined) e.preventDefault();
																		//setOpenPaymentOptionsModal(true);
																		setOpenInvoicesModal(true);
																	}}
																	style={styles.blocInfoHeader.button}
																>
																	Encaissement
																</Button>
															)}

															<Modal open={openPaymentOptionsModal}>
																<Modal.Header>{t("folderManager.paimentSolutions")}</Modal.Header>
																<Modal.Content>
																	<Dimmer active={paymentOptionsModalLoading}>
																		<Loader size="big">{t("folderManager.processing")}</Loader>
																	</Dimmer>
																	<Segment.Group>
																		{folderManager.paid.payments && amoutAlreadyPaid() > 0 && (
																			<>
																				<Segment>{t("folderManager.collectedPayment", { amoutAlreadyPaid: amoutAlreadyPaid() })}</Segment>
																				<Segment.Group>
																					{getPaymentsBySource()?.map((p, index) => (
																						<Segment key={`payment-${index}`}>
																							<Label basic as="span">
																								{p.price} €{" "}
																								{p.source === "stripe"
																									? t("folderManager.stripe")
																									: p.source === "voucher"
																									? t("folderManager.voucher", { voucherCode: p.voucher_code })
																									: p.source === "servipay"
																									? t("folderManager.servipay")
																									: p.source === "especes"
																									? t("folderManager.cash")
																									: p.source}
																								{p.invoice_reference
																									? t("folderManager.invoiceReference", { invoiceReference: p.invoice_reference })
																									: ""}
																							</Label>
																							{!p.invoice_reference &&
																								p.source !== "stripe" &&
																								p.source !== "voucher" &&
																								data.infos.prescriptionStatus &&
																								!data.isDone && (
																									<Button
																										icon
																										color="red"
																										onClick={() => {
																											setConfirmCancelPaymentId(p.key);
																											setConfirmCancelPaiementOpen(true);
																										}}
																									>
																										<Icon name="trash alternate" />
																										{t("folderManager.cancel")}
																									</Button>
																								)}
																						</Segment>
																					))}
																				</Segment.Group>
																			</>
																		)}
																		{amountToPay() > 0 && <Segment>{t("folderManager.AmountToBeCollected", { amountToPay: amountToPay() })}</Segment>}
																	</Segment.Group>
																	{amountToPay() && isPaymentEnabled() && (
																		<Card.Group itemsPerRow={isMobile() ? 1 : 3}>
																			<Card>
																				<Card.Content>
																					<Image floated="right" size="mini" src={servipay} />
																					<Card.Header>Servipay</Card.Header>
																				</Card.Content>
																				<Card.Content extra>
																					<Button
																						compact
																						onClick={(e) => {
																							if (e !== undefined) e.preventDefault();
																							setPaymentOptionsModalLoading(true);
																							addPayment("servipay", data.folders[0].id, null, amountToPay(), true, null, getPaymentPartition()).then(
																								() => {
																									setOpenPaymentOptionsModal(false);
																									setPaymentOptionsModalLoading(false);
																								}
																							);
																						}}
																					>
																						{t("folderManager.confirmServipay", { amountToPay: amountToPay() })}
																					</Button>
																				</Card.Content>
																			</Card>
																			<Card>
																				<Card.Content>
																					<Image src={cash} floated="right" size="mini" />
																					<Card.Header>{t("folderManager.cash")}</Card.Header>
																				</Card.Content>
																				<Card.Content extra>
																					<Button
																						compact
																						onClick={(e) => {
																							if (e !== undefined) e.preventDefault();
																							setPaymentOptionsModalLoading(true);
																							addPayment("cash", data.folders[0].id, null, amountToPay(), true, null, getPaymentPartition()).then(
																								() => {
																									setOpenPaymentOptionsModal(false);
																									setPaymentOptionsModalLoading(false);
																								}
																							);
																						}}
																					>
																						{t("folderManager.confirmCash", { amountToPay: amountToPay() })}
																					</Button>
																				</Card.Content>
																			</Card>
																			<Card>
																				<Card.Content>
																					<Image src={sumup} floated="right" size="mini" />
																					<Card.Header>Sumup</Card.Header>
																				</Card.Content>
																				<Card.Content extra>
																					<Button
																						compact
																						onClick={(e) => {
																							if (e !== undefined) e.preventDefault();
																							setPaymentOptionsModalLoading(true);
																							addPayment("sumup", data.folders[0].id, null, amountToPay(), true, null, getPaymentPartition()).then(
																								() => {
																									setOpenPaymentOptionsModal(false);
																									setPaymentOptionsModalLoading(false);
																								}
																							);
																						}}
																					>
																						{t("folderManager.confirmSumup", { amountToPay: amountToPay() })}
																					</Button>
																				</Card.Content>
																			</Card>
																		</Card.Group>
																	)}
																</Modal.Content>

																<Modal.Actions>
																	<Button
																		content={t("folderManager.close")}
																		onClick={() => {
																			setPaymentOptionsModalLoading(false);
																			setOpenPaymentOptionsModal(false);
																		}}
																	/>
																</Modal.Actions>
															</Modal>
														</Grid.Column>
													</Grid.Row>
												</Grid>
											)}
										</Grid.Column>
										<Grid.Column mobile={16} tablet={5} computer={5}>
											<Field
												type="text"
												name="comment"
												customlabel={t("folderManager.folderObservation")}
												component={CustomTextareaComponent}
												rows={3}
												disabled={data.isDone}
												onBlur={submitForm}
											/>
										</Grid.Column>
										<Grid.Column mobile={16} tablet={5} computer={5}>
											{showPatientPostIt && (
												<Field
													type="text"
													name="post_it"
													customlabel={t("folderManager.patientObservation", {
														date: data.patient.last_update_post_it
															? `- modifié le ${moment(data.patient.last_update_post_it).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)}`
															: "",
													})}
													component={CustomTextareaComponent}
													rows={3}
													disabled={data.isDone}
													onBlur={submitForm}
												/>
											)}
											{!showPatientPostIt && (
												<div
													style={{
														fontSize: "0.8em",
														marginTop: 5,
														marginLeft: 2,
													}}
												>
													{t("folderManager.patientObservation", {
														date: data.patient.last_update_post_it
															? `- modifié le ${moment(data.patient.last_update_post_it).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)}`
															: "",
													})}
												</div>
											)}
											<div>
												<Link
													to="/#"
													className="post-it-link"
													onClick={(e) => {
														if (e !== undefined) e.preventDefault();
														toggleShowPatientPostIt();
													}}
												>
													{t("folderManager.showPatientPostIt", { showPatientPostIt: showPatientPostIt ? "Cacher" : "Afficher" })}
												</Link>
											</div>
										</Grid.Column>
									</Grid.Row>
								</Grid>
							</Grid.Column>
						</Grid.Row>
					</MainButtonsContainer>
					{!data.isDone &&
						folderManager.paid &&
						folderManager.paid.payments &&
						folderManager.paid.payments.length > 0 &&
						confirmCancelPaymentId > 0 && (
							<Confirm
								open={confirmCancelPaiementOpen}
								content={t("folderManager.cancelPayment")}
								cancelButton={t("folderManager.no")}
								confirmButton={t("folderManager.yes")}
								onCancel={(e) => {
									if (e !== undefined) e.preventDefault();
									setConfirmCancelPaymentId(0);
									setConfirmCancelPaiementOpen(false);
								}}
								onConfirm={(e) => {
									if (e !== undefined) e.preventDefault();
									folderPaymentCancel(data.folders[0].id, confirmCancelPaymentId).then(() => {
										setConfirmCancelPaymentId(0);
										setConfirmCancelPaiementOpen(false);
									});
								}}
							/>
						)}
					<TotalCostModal
						open={totalCostModal}
						close={() => setTotalCostModal(false)}
						folderCode={data.folders[0].code}
						folderId={data.folders[0].id}
						patientEmail={data.patient.email}
						patientPhone={
							data.patient.mobile_phone?.replace(/\s/g, "")?.replace("+", "00") || data.patient.phone?.replace(/\s/g, "")?.replace("+", "00")
						}
						paid={folderManager.paid}
						prescriptions={data.prescriptions}
						costs={analysisLibraryCosts}
					/>
					<PaymentModal
						t={t}
						open={openInvoicesModal}
						close={() => setOpenInvoicesModal(false)}
						folderIsDone={data.isDone}
						paid={folderManager.paid}
						prescriptionStatus={data.infos.prescriptionStatus}
						costs={analysisLibraryCosts}
						costsPatient={costs?.totalCosts?.patient}
						folderId={data.folders[0].id}
						folderPaymentCancel={folderPaymentCancel}
						addPayment={addPayment}
						invoices={invoices}
						center={data.folders[0]?.center}
						folderPaymentRef={folderPaymentRef}
					/>
				</Form>
			)}
		</Formik>
	);
};
export default FolderSection;
